import { Action } from "../../utils/types";
import Button, { ButtonProps } from "../Button/Button";
import Icon, { IconProps } from "../Icon/Icon";
import { Text } from "../typography/Text";

interface BannerActionProps extends Action, Pick<ButtonProps, "iconOnly"> {
  iconName?: IconProps["name"];
  isPrimary?: boolean;
  isBar: boolean;
  isOat: boolean;
  isBlue: boolean;
}

const BannerAction = ({
  iconOnly,
  onClick,
  label,
  isPrimary,
  isBar,
  isOat,
  isBlue,
  iconName,
  ...props
}: BannerActionProps) => {
  const commonProps: ButtonProps = {
    ...props,
    iconOnly,
    onClick,
    children:
      iconOnly && iconName ? <Icon name={iconName} /> : <Text>{label}</Text>,
  };
  if (isPrimary) {
    const hierarchy = isOat
      ? "primary-bold"
      : isBlue
        ? "brand-reversed-bold"
        : "reversed-subtle";

    return <Button {...commonProps} hierarchy={hierarchy} />;
  }

  const hierarchyOatBtn = isBar ? "primary-subtler" : "primary-subtle";
  const hierarchyBlueBtn = isBar ? "reversed-subtler" : "reversed-subtle";
  const hierarchy = isOat
    ? hierarchyOatBtn
    : isBlue
      ? hierarchyBlueBtn
      : "reversed-subtler";

  return <Button {...commonProps} hierarchy={hierarchy} />;
};

export default BannerAction;
